export default __webpack_public_path__ + "static/media/LoaderLogo.daa219e2.png";